import Vue from 'vue'

import ProjectList from './components/ProjectList.vue'

import axios from 'axios'
axios.defaults.baseURL = 'https://bma1915.com/projects/json'
axios.defaults.headers.get['Accepts'] = 'application/json'

new Vue({
  el: '#app',
  components: {
    'project-list': ProjectList,
  }
})



// WEBPACK FOOTER //
// ./src/main.js